import { useTheme } from "next-themes";
import { Toaster as Sonner, ToasterProps } from "sonner";
import React from "react";
import {
  CircleAlertIcon,
  CircleCheckIcon,
  CircleXIcon,
  LoaderIcon,
} from "lucide-react";

const Toaster = ({ ...props }: ToasterProps) => {
  const { theme = "system" } = useTheme();

  return (
    <Sonner
      theme={theme as ToasterProps["theme"]}
      position="bottom-center"
      icons={{
        success: <CircleCheckIcon aria-hidden="true" className="w-5 h-5" />,
        warning: <CircleAlertIcon aria-hidden="true" className="w-5 h-5" />,
        error: <CircleXIcon aria-hidden="true" className="w-5 h-5" />,
        info: <LoaderIcon aria-hidden="true" className="w-5 h-5" />,
      }}
      style={
        {
          "--width": "100%",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
        } as React.CSSProperties
      }
      toastOptions={{
        unstyled: true,
        classNames: {
          toast:
            "mx-5 text-white min-h-12 rounded-lg grid grid-cols-[auto_1fr_auto_auto] pl-2 overflow-hidden",
          content: "py-2 pr-4 text-sm flex items-center justify-center",
          icon: "h-full! w-auto! flex items-center justify-center pl-3 pr-3",

          // Buttons
          actionButton:
            "min-w-12 px-3 flex items-center justify-center border-l border-white/20 hover:bg-black/10",
          cancelButton:
            "w-12 flex items-center justify-center border-l border-white/20 hover:bg-black/10",

          // Copy
          title: "leading-6 font-normal",
          description: "leading-6 font-normal",

          // Toast colors
          success: "bg-system-success",
          warning: "bg-system-warning",
          error: "bg-system-error",
          info: "bg-tertiary-600",
        },
      }}
      {...props}
    />
  );
};

export { Toaster };
